// src/components/MobileBottomBar.jsx
import React, { useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { Paper, BottomNavigation, BottomNavigationAction, useTheme, useMediaQuery, Avatar } from "@mui/material";
import Iconify from "./Iconify";
import { UserAuth } from "../context/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.config";
import SwipeD from "./swipeable/Swipe";
import { Variables } from "../context/VariableContext";

const TABS = [
    // key = valeur contrôlée par BottomNavigation
    { key: "home", label: "Accueil", icon: "carbon:home", to: "/fr/", pattern: "/fr/", end: true },
    { key: "search", label: "Recherche", icon: "carbon:search", to: "/fr/all--city/all--event", pattern: "/fr/all--city/all--event", end: true },
    { key: "tickets", label: "Billets", icon: "carbon:ticket", to: "/fr/account/tickets", pattern: "/fr/account/tickets", end: false },
    { key: "account", label: "Compte", icon: "carbon:user-avatar", to: "/fr/account", pattern: "/fr/account", end: false },
];

export default function MobileBottomBar() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // xs / sm
    const { user, logIn } = UserAuth();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [openConnexion, setOpenConnexion] = React.useState(false);
    const [connexion, setConnexion] = React.useState(true);
    const [count, setCount] = React.useState(0);
    const { setOpenLogin } = Variables();

    const [photoUrl, setPhotoUrl] = useState(null);

    // 🔹 Récupère la photo du user connecté
    useEffect(() => {
        const fetchProfile = async () => {
            if (user?.uid) {
                const docSnap = await getDoc(doc(db, "users", user.uid));
                if (docSnap.exists()) {
                    setPhotoUrl(docSnap.data().photoUrl || null);
                }
            }
        };
        fetchProfile();
    }, [user]);

    if (!isMobile) return null;

    const isEventPage =
        matchPath({ path: "/event/:id" }, pathname) ||
        matchPath({ path: "/fr/event/:id" }, pathname);

    if (isEventPage) return null;

    // Trouver l’onglet actif en fonction de l’URL
    const currentKey =
        TABS.find(t => !!matchPath({ path: t.pattern, end: t.end ?? false }, pathname))?.key
        ?? "home";

    return (
        <Paper
            elevation={8}
            sx={{
                position: "fixed",
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: theme.zIndex.appBar + 1,
                backdropFilter: "blur(8px)", // effet flou type iOS
                backgroundColor: "rgba(255, 255, 255, 0.8)", // blanc légèrement transparent
            }}
        >
            <BottomNavigation
                showLabels={false}
                value={currentKey}
                onChange={(_, newKey) => {
                    const tab = TABS.find(t => t.key === newKey);
                    if (tab) navigate(tab.to);
                }}
                sx={{
                    bgcolor: "transparent",
                    "& .MuiBottomNavigationAction-root": {
                        color: "#777",
                        minWidth: "unset",
                        paddingY: 1,
                    },
                    "& .Mui-selected, & .Mui-selected .MuiSvgIcon-root": {
                        color: "#5E17EB", // couleur violette Choptonticket
                        transform: "scale(1.05)",
                        transition: "all 0.2s ease",
                    },
                }}
            >
                {TABS.map((t) => {
                    // Si c’est l’onglet "Compte" et qu’un user est connecté → affiche la photo
                    const isProfileTab = t.key === "account";
                    const icon =
                        isProfileTab && user && photoUrl ? (
                            <Avatar
                                src={photoUrl}
                                sx={{
                                    width: 30,
                                    height: 30,
                                    border: currentKey === "account" ? "1px solid #5E17EB" : "1px solid transparent",
                                }}
                            />
                        ) : isProfileTab && user ? (
                            <Avatar
                                sx={{
                                    width: 30,
                                    height: 30,
                                    border: currentKey === "account" ? "1px solid #5E17EB" : "1px solid transparent",
                                }}
                            />
                        ) : (
                            <Iconify icon={t.icon} sx={{ width: 25, height: 25 }} />
                        );

                    return (
                        <BottomNavigationAction
                            key={t.key}
                            value={t.key}
                            // label={t.label}
                            icon={icon}
                        />
                    );
                })}
            </BottomNavigation>
        </Paper>
    );
}
